import { FunctionChildren } from '@components/table/models/types';
import { Box } from '@material-ui/core';
import React, { ReactElement } from 'react';
import { EColumnDataType } from '../models/col-data-type';

type TableCellProps = {
  data?: any;
  type?: EColumnDataType;
  children?: FunctionChildren | ReactElement;
  disableClickAction?: boolean;
  align?: 'left' | 'right' | 'inherit' | 'center' | 'justify' | undefined;
};

export const SwyftTableCell = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  children
}: Pick<TableCellProps, 'children'>): JSX.Element => <div />;

export const SwyftTableInnerCell = ({ data, align }: Omit<TableCellProps, 'children'>): JSX.Element => {
  return <Box textAlign={align}>{data}</Box>;
};
